module.exports = __webpack_public_path__ + "static/img/cq101w.1804df72.png";